export const ConsumerEmailErrorUat = {
  error: 'consumerEmail.generalError',
}
